import gsap from "gsap";

/**
 *  Updates color of the wave to new product color
 * and repositions them offscreen on the lefthand side.
 *
 * @param data {object}  object containing data from selected product swatch
 * @param overlayEl {element} overlay element behind
 * @param waveEl {element} wave element moving across page
 */
export const waveUnderBefore = (data, overlayEl, waveEl) => {
  gsap.defaults({ overwrite: true });
  const { trigger } = data;

  overlayEl.style.background = trigger.dataset.colorLight;
  waveEl.style.display = "block";
  waveEl.setAttribute("fill", `${trigger.dataset.colorLight}`);

  gsap.set(overlayEl, {
    x: "-100%",
  });
};

/**
 *
 * Moves wave from left to right side of screen. Once the wave is fully across
 * update the css variables from the selected swatch
 *
 * @param data {object}  object containing data from selected product swatch
 * @param overlayEl {element} overlay element behind
 */
export const waveUnderLeave = (data, overlayEl) => {
  gsap.defaults({ overwrite: true });
  const { trigger } = data;

  // speed up wave animation on smaller screen resolutions
  const duration = window.innerWidth >= 1024 ? 1 : 0.85;
  const delay = window.innerWidth >= 1024 ? ".50" : ".25";

  return gsap
    .timeline()
    .to(overlayEl, { duration: 0, background: `${trigger.dataset.overlay}` })
    .to(
      overlayEl,
      {
        duration,
        x: "100%",
        onComplete: function () {
          document.documentElement.style.setProperty(
            "--flavor-color-100",
            `${trigger.dataset.colorLight}`
          );
        },
      },
      "<"
    )
    .call(
      () => {
        document.documentElement.style.setProperty(
          "--flavor-color-200",
          `${trigger.dataset.colorMedium}`
        );
        document.documentElement.style.setProperty(
          "--flavor-color-300",
          `${trigger.dataset.colorDark}`
        );
      },
      null,
      delay
    );
};
